var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8467_2912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0235 25.7892C26.4525 25.7892 31.6642 20.5775 31.6642 14.1485C31.6642 7.71954 26.4525 2.50781 20.0235 2.50781C13.5945 2.50781 8.38281 7.71954 8.38281 14.1485C8.38281 20.5775 13.5945 25.7892 20.0235 25.7892Z",
    stroke: "#1E1E20",
    strokeWidth: 3.32592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7192 23.9434L11.707 39.0929L20.0218 34.1041L28.3366 39.0929L26.3244 23.9268",
    stroke: "#1E1E20",
    strokeWidth: 3.32592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8467_2912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.911,
    height: 39.911,
    fill: "white",
    transform: "translate(0.0664062 0.844727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconAward);
export default __webpack_public_path__ + "static/media/gat-icon-award.3efcddbece0d9cd6e3ae6d1659438b19.svg";
export { ForwardRef as ReactComponent };